<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('mentora_time_of_requests')"
                        :isNewButton="checkPermission('mentora_time_of_requests')"
                        @filter-div-status="datatable.filterStatus = $event">
                </Header>
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('mentora_time_of_requests')"
                              :isNewButton="checkPermission('mentora_time_of_requests')"
                              @filter-div-status="datatable.filterStatus = $event">
                </HeaderMobile>
            </template>
            <datatable-filter v-show="datatable.filterStatus"
                              @filter="filter"
                              @filterClear="filterClear"
            >
                <b-row>
                    <b-col sm="6" md="6" lg="3" xl="3">
                        <b-form-group :label="$t('student_number')">
                            <b-form-input size="sm"
                                          v-model="datatable.queryParams.filter.student_number"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6" md="6" lg="3" xl="3">
                        <b-form-group :label="$t('name')">
                            <b-form-input size="sm" v-model="datatable.queryParams.filter.name"
                                         ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6" md="6" lg="3" xl="3">
                        <b-form-group :label="$t('surname')">
                            <b-form-input size="sm" v-model="datatable.queryParams.filter.surname"
                                         ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6" md="6" lg="3" xl="3">
                        <b-form-group :label="$t('module')">
                            <module-date-selectbox ref="moduleDate" v-model="datatable.queryParams.filter.selected_sessions" :multiple="true"></module-date-selectbox>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6" md="6" lg="3" xl="3">
                        <b-form-group :label="$t('status')">
                            <parameter-selectbox code="student_time_off_request_status" v-model="datatable.queryParams.filter.status"></parameter-selectbox>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6" md="6" lg="3" xl="3">
                         <b-form-group :label="$t('start_date')">
                            <select-date v-model="datatable.queryParams.filter.created_at_greater_than"/>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6" md="6" lg="3" xl="3">
                        <b-form-group :label="$t('end_date')">
                            <select-date v-model="datatable.queryParams.filter.created_at_smaller_than"/>
                        </b-form-group>
                    </b-col>
                </b-row>
            </datatable-filter>
            <datatable :isLoading.sync="datatable.isLoading"
                       :columns="datatable.columns"
                       :rows="datatable.rows"
                       :total="datatable.total"
                       :queryParams="datatable.queryParams"
                       @on-page-change="onPageChange"
                       @on-sort-change="onSortChange"
                       @on-per-page-change="onPerPageChange"
                       v-show="datatable.showTable"
            >
            </datatable>
        </app-layout>
    </div>
</template>
<script>
    //Template
    import AppLayout from "@/layouts/AppLayout";
    import Header from "@/layouts/AppLayout/Header"
    import HeaderMobile from "@/layouts/AppLayout/HeaderMobile"
    //Component
    import DatatableFilter from "@/components/datatable/DatatableFilter";
    import Datatable from "@/components/datatable/Datatable";
    import CommonModal from "@/components/elements/CommonModal";
    //Other
    import qs from "qs";
    //Service
    import MentoraTimeOfRequestService from "@/services/MentoraTimeOffRequestFormServices";
    import AcademicYearsSelectbox from "@/components/interactive-fields/AcademicYearsSelectbox.vue";
    import HousingReservationPaymentService from "@/services/HousingReservationPaymentService";
    import ModuleDateSelectbox from "@/components/interactive-fields/ModuleDateSelectbox.vue";


    export default {
        components: {
            ModuleDateSelectbox,
            AcademicYearsSelectbox,
            AppLayout,
            Header,
            HeaderMobile,
            DatatableFilter,
            Datatable,
            CommonModal,
        },
        metaInfo() {
            return {
                title: this.$t("mentora_time_of_requests"),
            };
        },
        computed:{
            userRoles(){
                return   this.$store.getters['auth/getActiveRole']
            },
        },
        data() {
            return {
                formId: 0,
                form: {},
                formProcess: null,
                datatable: {
                    isLoading: false,
                    columns: [
                        {
                            label: "",
                            field: "buttons",
                            html: true,
                            sortable: false,
                            tdClass: "p-0 text-center w-40 align-middle",
                            buttons: [
                                {
                                    text: this.$t("detail"),
                                    class: "ri-edit-box-line",
                                    permission: 'studenttimeoffrequest_show',
                                    callback: (row) => {
                                        this.$router.push('/mentora/time/off/request-detail/' + row.id)
                                    },
                                    show:()=>{
                                        return true
                                        // return ['MA'].includes(this.userRoles)
                                    }
                                },
                                {
                                    text: this.$t('delete'),
                                    class: 'ri-delete-bin-2-line',
                                    permission:'studenttimeoffrequest_delete',
                                    callback: (row) => {
                                        this.deleteRequests(row.id);
                                    }
                                },
                            ],
                        },
                        {
                            label: this.$t("student_id"),
                            field: "student_number",
                            sortable: false,
                        },
                        {
                            label: this.$t("name"),
                            field: "name",
                            sortable: true,
                        },
                        {
                            label: this.$t("surname"),
                            field: "surname",
                            sortable: true,
                        },
                        {
                            label: this.$t("status"),
                            field: "status_name",
                            sortable: false,
                        },
                    ],
                    rows: [],
                    total: 0,
                    filterStatus: true,
                    showTable: false,
                    queryParams: {
                        filter: {},
                        sort: "id",
                        page: 1,
                        limit: 20,
                    },
                },
            };
        },
        methods: {
            filter() {
                this.datatable.queryParams.page = 1;
                this.getRows();
            },
            filterClear() {
                this.datatable.queryParams.filter = {};
                this.getRows();
            },
            onPageChange(params) {
                this.datatable.queryParams.page = params.currentPage;
                this.getRows();
            },
            onPerPageChange(params) {
                this.datatable.queryParams.limit = params.currentPerPage;
                this.datatable.queryParams.page = 1;
                this.getRows();
            },
            onSortChange(params) {
                const sortType = params[0].type == "desc" ? "-" : "";
                this.datatable.queryParams.sort = sortType + params[0].field;
                this.getRows();
            },
            getRows() {
                this.datatable.showTable = true;
                this.datatable.isLoading = true;

                const config = {
                    params: {
                        ...this.datatable.queryParams,
                    },
                    paramsSerializer: (params) => qs.stringify(params, {encode: false}),
                };

                return MentoraTimeOfRequestService.getAll(config)
                                           .then((response) => {
                                               this.datatable.rows = response.data.data;
                                               this.datatable.total = response.data.pagination.total;
                                           })
                                           .finally(() => {
                                               this.datatable.isLoading = false;
                                           });
            },

            deleteRequests(id){
                this.deleteModal(() => {
                    MentoraTimeOfRequestService.del(id)
                        .then(response => {
                            this.getRows();
                            this.$toast.success(this.$t('api.' + response.data.message));
                        })
                        .catch(error => {
                            this.$toast.error(this.$t('api.' + error.data.message));
                        });
                });
            },


            showForm(id) {
                this.formId = id
                this.formProcess = 'show'
                this.$refs.showModal.$refs.commonModal.show()
            },
        },
    };
</script>

